import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DataService {
  url = "https://api.edamam.com/api/food-database/parser";
  app_id = "98697eb1";
  app_key = "aece7e44fc7c61ca562eeca80e4c1a3e";
  data= [];

  results = [];

  cart = [];

  images = [
    {
      id: 1,
      image: "",
    },
    {
      id: 2,
      image: "",
    },
    {
      id: 3,
      image: "",
    },
    {
      id: 4,
      image: "",
    },
    {
      id: 5,
      image: "",
    },
    {
      id: 6,
      image: "",
    },
  ];

  cardInf = [
    {
      id: 1,
      name: "Meat",
      url: "assets/icons/meat.svg",
      color: "green",
    },
    {
      id: 2,
      name: "Dairy",
      url: "assets/icons/dairy.svg",
      color: "red",
    },
    {
      id: 3,
      name: "Snacks",
      url: "assets/icons/snacks.svg",
      color: "blue",
    },
    {
      id: 4,
      name: "Keto",
      url: "assets/icons/keto.svg",
      color: "yellow",
    },
    {
      id: 5,
      name: "Vegan",
      url: "assets/icons/vegan.svg",
      color: "light-green",
    },
    {
      id: 6,
      name: "GF",
      url: "assets/icons/gluten.svg",
      color: "black",
    },
  ];

  constructor(private http: HttpClient) {}

  getProductSearchResult(title: string){
     return this.http.get( `${this.url}?ingr=${encodeURI(title)}&app_id=${this.app_id}&app_key=${this.app_key}`)
          .pipe(map(res => res['hints']))
          
  }

  getProduct() {
    return this.cart
    
    
  }

  getCategories() {
    // return this.http.get( `${this.url}?ingr=${encodeURI(name)}&app_id=${this.app_id}&app_key=${this.app_key}`)
    // .pipe(map(res => res['hints']))
    return this.cardInf
    
  }

  getShoppingList() {
    return this.http.get( `${this.url}?category="apple"&app_id=${this.app_id}&app_key=${this.app_key}`)
    .pipe(map(res => res['cart']));
  }


  getCategoyById(id: number) {
    return this.http.get( `${this.url}?category="general"&app_id=${this.app_id}&app_key=${this.app_key}`)
    .pipe(map(res => res['hints.food.category']));
    
    
  }

  deleteData(id: number) {
    return (this.data = this.data.filter((data: any) => data.id !== id));
  }

  addProduct(item) {
    this.cart.push(item)
    console.log(item)
  }
  clearCart(){
    this.cart = [];
  }
}
